import { loading, success, error } from 'State/actions';
import * as types from './types';

export const getTaxRateSetup = () => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.TAXRATE_LOADING, true));

      const response = await MPWWebApi.getGeneric('taxrate');

      dispatch(success(types.TAXRATE_GET, response));
    } catch (ex) {
      dispatch(
        error(types.TAXRATE_ERROR, {
          title: 'Error',
          Message: 'Unable to get Tax Rates',
        })
      );
    } finally {
      dispatch(loading(types.TAXRATE_LOADING, false));
    }
  };
};

export const saveTaxRate = (data) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.TAXRATE_LOADING, true));

      await MPWWebApi.postGenericInsertUpdate('taxRate', data);

      await dispatch(getTaxRateSetup());

      dispatch(setSaveSuccessful(true));
    } catch (ex) {
      dispatch(
        error(types.TAXRATE_ERROR, {
          title: 'Error',
          Message: 'Unable to add or update Tax Rate',
        })
      );
    } finally {
      dispatch(loading(types.TAXRATE_LOADING, false));
    }
  };
};

export const deleteTaxRate = (id) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.TAXRATE_LOADING, true));

      const response = await MPWWebApi.postGenericDelete('taxrate', id);

      if (response) {
        dispatch(setDeleteSuccessful(true));
        await dispatch(getTaxRateSetup());
      }
    } catch (ex) {
      dispatch(
        error(types.TAXRATE_ERROR, {
          title: 'Error',
          Message: 'Unable to delete Tax Rate',
        })
      );
    } finally {
      dispatch(loading(types.TAXRATE_LOADING, false));
    }
  };
};

export const saveTaxRateSites = (model) => {
  return async (dispatch, getState, MPWWebApi) => {
    try {
      dispatch(loading(types.TAXRATE_LOADING, true));
      const response = await MPWWebApi.postGenericInsertUpdate(
        'TaxRate/WriteTaxRateSites',
        model
      );
      if (response) {
        dispatch(setSaveSitesSuccessful(true));
      }
    } catch (ex) {
      dispatch(error(types.TAX_RATE_SETUP_SAVE_SITES_ERROR));
    } finally {
      dispatch(loading(types.TAXRATE_LOADING, false));
    }
  };
};

export const setSaveSitesSuccessful = (isSuccess) => {
  return {
    type: types.TAX_RATE_SETUP_SAVE_SITES_SUCCESSFUL,
    payload: isSuccess,
  };
};

export const setSaveSuccessful = (isSuccess) => {
  return {
    type: types.TAX_RATE_SETUP_SAVE_SUCCESSFUL,
    payload: isSuccess,
  };
};

export const setDeleteSuccessful = (isSuccess) => {
  return {
    type: types.TAX_RATE_SETUP_SAVE_DELETE_SUCCESSFUL,
    payload: isSuccess,
  };
};

export const clearErrors = () => {
  return {
    type: types.TAX_RATE_SETUP_CLEAR_ERRORS,
  };
};



// WEBPACK FOOTER //
// ./src/pages/controlinformation/state/taxRates/actions.js